import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import React from "react";

import { useCelleraTheme } from "../../../theme/useCelleraTheme";

interface IntakeCheckboxFieldProps {
  label: string;
  value: boolean;
  disabled?: boolean;
}

const IntakeCheckboxField: React.FC<IntakeCheckboxFieldProps> = ({
  label,
  value,
  disabled = true,
}) => {
  const { colors } = useCelleraTheme();

  return (
    <Box sx={{ mb: 2 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={value}
            disabled={disabled}
            sx={{
              color: colors.primary.main,
              "&.Mui-checked": {
                color: colors.primary.main,
              },
              "&.Mui-disabled": {
                color: colors.text.disabled,
              },
            }}
          />
        }
        label={
          <Typography
            variant="body2"
            sx={{
              color: colors.text.secondary,
              fontWeight: 500,
            }}
          >
            {label}
          </Typography>
        }
        sx={{
          alignItems: "center",
          "& .MuiFormControlLabel-label": {
            marginTop: "0px",
          },
        }}
      />
    </Box>
  );
};

export default IntakeCheckboxField;
